export const errorMessages = {
  isRequired: 'This Field is required',
  maxLength: 'This field should not be longer than 30 characters',
  maxLength_300: 'This field should not be longer than 2000 characters',
  isEmail: 'This is not a valid email',
  isUrl: 'This field should represent an URL',
  minLength: 'This field should be at least 8 characters Long',
  maxLength_30: 'This field should not be longer than 30 characters',
  oneUppercase: 'The password should contain at least one uppercase ',
  oneLowercase: 'The password should contain at least one lowercase ',
  oneDigit: 'The password should contain at least one number ',
  oneSpecialCharacter: 'The password should contain at least one special character',
  validName: 'This in not a valid name',
}

export const errorMessagesSignUp = {
  isRequired: 'is required',
  maxLength: 'should not be longer than 50 characters',
  maxLengthPassword: 'should not be longer than 30 characters',
  isEmail: 'This is not a valid email',
  minLength: 'should be at least 8 characters Long',
  oneUppercase: 'The password should contain at least one uppercase ',
  oneLowercase: 'The password should contain at least one lowercase ',
  oneDigit: 'The password should contain at least one number ',
  oneSpecialCharacter: 'The password should contain at least one special character',
  validName: 'is not a valid name',
  freeDomainEmail: 'Invalid email address. Please use your company email.',
}
